const AdminValidate = () =>
  import ('@/pc/views/admin/validate/index');
const AdminValidateRecord = () =>
  import ('@/pc/views/admin/validate/record');
const AdminReport = () =>
  import ('@/pc/views/admin/reports/index');
const AdminMarketing = () =>
  import ('@/pc/views/admin/marketing/index');
const AdminMarketingDetail = () =>
  import ('@/pc/views/admin/marketing/couponDetail');
const AdminStore = () =>
  import ('@/pc/views/admin/stores/index');
const Assistants = () =>
  import ('@/pc/views/admin/stores/assistants');
const AdminSettlement = () =>
  import ('@/pc/views/admin/settlement/index');
const AdminCard = () =>
  import ('@/pc/views/admin/settlement/card');
const AdminOverview = () =>
  import ('@/pc/views/admin/dataCenter/overview');
const AdminIntention = () =>
  import ('@/pc/views/admin/dataCenter/intention');



// 没有label标识隐藏菜单 即有路由但是不显示在菜单中
var BASEMENU = [{
    label: '首页',
    index: '/admin/index',
    icon: 'iconfont-home',
    component: AdminValidate,
    menus: [{
      //  label:'验券记录',//单天
      index: '/admin/index/record',
      component: AdminValidateRecord
    }]
  }, {
    label: '报表管理',
    index: '/admin/report/index',
    icon: 'iconfont-graph',
    menus: [{
      label: '验券报表',
      index: '/admin/report',
      component: AdminReport
    }]
  }, {
    label: '营销管理',
    index: '/admin/marketing/index',
    icon: 'iconfont-marketing',
    menus: [{
      label: '代金券',
      index: '/admin/marketing',
      component: AdminMarketing
    }, {
      // label: '代金券详情',
      index: '/admin/marketing/:id',
      component: AdminMarketingDetail
    }]
  }, {
    label: '门店管理',
    index: '/admin/store/index',
    icon: 'iconfont-border-store',
    menus: [{
      label: '门店展示',
      index: '/admin/store',
      component: AdminStore
    }, {
      label: '我的店员',
      index: '/admin/assistants',
      component: Assistants
    }]
  }, {
    label: '结算记录',
    index: '/admin/settlement',
    icon: 'iconfont-record',
    component: AdminSettlement,
    // 账户信息去掉
    // menus: [{
    //   //  label: '账户信息',
    //   index: '/admin/settlement/card',
    //   component: AdminCard
    // }]
  },
  // {
  //   label: '数据中心',
  //   index: '/admin/dataCenter/index',
  //   icon: 'iconfont-record',
  //   menus: [{
  //       label: '经营概览',
  //       index: '/admin/dataCenter/overView',
  //       component: AdminOverview
  //     }
  //     // , {
  //     //   label: '客户意向',
  //     //   index: '/admin/dataCenter/intention',
  //     //   component: AdminIntention
  //     // }
  //   ]
  // }
]
// , {
//   label: '数据中心',
//   index: '/admin/dataCenter',
//   icon: 'iconfont-record',
//   menus: [{
//     label: '经营概览',
//     index: '/admin/dataCenter/overView',
//     component: AdminOverview
//   }, {
//     label: '客户意向',
//     index: '/admin/dataCenter/intention',
//     component: AdminIntention
//   }]
// }


const pickByKey = (iterator, key, value) => {
  for (var i in iterator) {
    if (iterator[i][key] == value) {
      return [iterator[i], i];
    }
  }
  return null;
}
const loopMenusDelete = (menus, index) => {
  var loop = (_menus) => {
    var resMenu = [];
    for (var i = _menus.length - 1; i >= 0; i--) {
      if (_menus[i].menus) {
        _menus[i]._originMenus = _menus[i].menus;
      }

      if (_menus[i].menus && _menus[i].menus.length) {
        _menus[i].menus = loop(_menus[i].menus);
      }

      if (!_menus[i].menus || !_menus[i].menus.length) {
        _menus[i].menus = null;
      }

      if (_menus[i].index != index) {
        resMenu.unshift(_menus[i]);
      }
    }
    return resMenu;
  }
  return loop(menus);
}

var recoverBase = () => {
  // BASEMENU
  var loop = (_menu) => {
    for (var i = 0, len = _menu.length; i < len; i++) {
      if (_menu[i]._originMenus) {
        _menu[i].menus = _menu[i]._originMenus;
      }
      if (_menu[i].menus) {
        _menu[i].menus = loop(_menu[i].menus);
      }
    }
    return _menu;
  }
  return loop(BASEMENU);
}

var limitedPrivileges = null;
var _getByPrivileges = (privileges = [], role) => {
  var _base = recoverBase();
  // 店主专有权限: 结算记录、账户、店员、数据中心
  if (role == 'owner') {
    return _base;
  }
  _base = loopMenusDelete(_base, '/admin/assistants');
  _base = loopMenusDelete(_base, '/admin/dataCenter');
  _base = loopMenusDelete(_base, '/admin/settlement');

  if (!privileges instanceof Array) {
    return [];
  }

  if (privileges == '*') {
    return _base
  }

  // 查看代金券
  var permitMarketing = pickByKey(privileges, 'nameEn', 'marketing');
  if (!permitMarketing || !permitMarketing[0] || !permitMarketing[0].available) {
    _base = loopMenusDelete(_base, '/admin/marketing/index');
  }

  // 验券权限
  var permitValidateVoucher = pickByKey(privileges, 'nameEn', 'validateVoucher');
  if (!permitValidateVoucher || !permitValidateVoucher[0] || !permitValidateVoucher[0].available) {
    _base = loopMenusDelete(_base, '/admin/index/record');
    _base = loopMenusDelete(_base, '/admin/report/index');
  }
  return _base;
}
var getByPrivileges = (privileges, role) => {
  if (limitedPrivileges) return limitedPrivileges;
  limitedPrivileges = _getByPrivileges(privileges, role);
  return limitedPrivileges;
}

const getMenu = (privileges = [], role) => {
  var handledMenu = getByPrivileges(privileges, role);
  // 删除所有没有label的菜单  即隐藏菜单
  var loopMenusDeleteNolabel = (menus) => {
    var loop = (_menus) => {
      var newMenus = [];
      for (var i = _menus.length - 1; i >= 0; i--) {
        if (!_menus[i].label) {
          continue;
        }
        if (_menus[i].menus && _menus[i].menus.length) {
          _menus[i].menus = loop(_menus[i].menus);
        } else {
          _menus[i].menus = null;
        }
        newMenus.unshift(_menus[i]);
      }
      return newMenus;
    }
    return loop(menus);
  }
  return loopMenusDeleteNolabel(handledMenu);
}

const getMenuRouter = (privileges = [], role) => {
  var handledRouter = getByPrivileges(privileges, role);
  const formatRouter = (_menu) => {
    var resMenu = []
    var loop = (_menus) => {
      for (var i = _menus.length - 1; i >= 0; i--) {
        if (_menus[i].component) {
          resMenu.push({
            path: _menus[i].index,
            component: _menus[i].component
          });
        }
        if (_menus[i].menus && _menus[i].menus.length) {
          loop(_menus[i].menus);
        }
      }
    }
    loop(_menu);
    return resMenu;
  }
  // console.log(formatRouter(handledRouter), privileges, role);
  return formatRouter(handledRouter);
}

export {
  getMenu,
  getMenuRouter
}



// WEBPACK FOOTER //
// ./src/pc/privileges/pcMenus.js